// Definitiile de coloane pentru tabelele CRM Contacts (companii/persoane).
// Extras din `NcrmContacts.vue` (fisier peste pragul de dimensiune) conform
// regulii din docs/engineering/modularity.md.
export const buildContactsTableHeaders = ({ t, activeTab }) => {
  if (activeTab === "companies") {
    return [
      { title: t("ncrm.contacts.headers.company"), key: "name" },
      { title: "", key: "mailjet_status", sortable: false, width: "32px", align: "center" },
      { title: t("ncrm.contacts.dataProtection.header"), key: "privacy_state", width: "172px",
        headerProps: { class: "ncrm-contacts-table__privacy-column" },
        cellProps: { class: "ncrm-contacts-table__privacy-column" } },
      { title: t("ncrm.contacts.headers.email"), key: "email", sortable: false },
      { title: t("ncrm.activity.lastCall.header"), key: "last_call", sortable: false },
      { title: t("ncrm.contacts.headers.phone"), key: "phone", sortable: false },
      { title: t("ncrm.contacts.headers.category"), key: "category", sortable: false },
      { title: t("ncrm.contacts.headers.source"), key: "source", sortable: false },
      { title: t("ncrm.contacts.headers.createdAt"), key: "createdAt" },
      { title: "", key: "row_nav", sortable: false, width: "48px" },
    ];
  }
  return [
    { title: t("ncrm.contacts.headers.person"), key: "name" },
    { title: t("ncrm.contacts.headers.company"), key: "company", sortable: false },
    { title: "", key: "mailjet_status", sortable: false, width: "32px", align: "center" },
    { title: t("ncrm.contacts.dataProtection.header"), key: "privacy_state", width: "172px",
      headerProps: { class: "ncrm-contacts-table__privacy-column" },
      cellProps: { class: "ncrm-contacts-table__privacy-column" } },
    { title: t("ncrm.contacts.headers.email"), key: "email", sortable: false },
    { title: t("ncrm.activity.lastCall.header"), key: "last_call", sortable: false },
    { title: t("ncrm.contacts.headers.phone"), key: "phone", sortable: false },
    { title: t("ncrm.contacts.headers.source"), key: "source", sortable: false },
    { title: t("ncrm.contacts.headers.createdAt"), key: "createdAt" },
    { title: "", key: "row_nav", sortable: false, width: "48px" },
  ];
};
